import { IRectangle, List } from '@fluentui/react';
import ProductItemView from './ProductItemView';
import { ProductKeyModel, ShortLineModel } from '../../models/ProductModel';
import { addCartFunc } from '../../../carts/views/CartView';

export type AdminProductGridProps = {
    lines: ShortLineModel[];
    onDetail: (key: ProductKeyModel) => void;
    onBarcode: (barcode: string) => void;
    isAdmin: boolean;
    isMobile: boolean;
    addToCart: addCartFunc;
    setFavorite: (lineId: number, isDeleted: boolean) => void;
}

export default function ProductGridView({
    lines, onDetail, onBarcode, isAdmin, isMobile, addToCart, setFavorite
}: AdminProductGridProps) {
    let columnCount: number = 0;
    const phPadding = isMobile ? "ph-10" : "ph-15";

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (isMobile) {
            columnCount = 2;
        } else if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 500) columnCount = 2;
            else if (surfaceRect != null && surfaceRect.width < 900) columnCount = 3;
            else columnCount = 4;
        }

        return lines.length;
    }

    const onRenderCell = (line?: ShortLineModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const height = 350;

        if (line == null) return <>empty</>;

        return <div
            key={line.id + "-wrapper"}
            className={"list-grid-tile pv-10 " + phPadding}
            data-is-focusable={true}
            style={{ width: width, height: height }}
        >
            <ProductItemView
                key={line.id}
                line={line}
                onDetail={onDetail}
                onBarcode={onBarcode}
                isAdmin={isAdmin}
                isMobile={isMobile}
                addToCart={addToCart}
                setFavorite={setFavorite}
            />
        </div>;
    }

    return <div>
        <List
            items={lines}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}